/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "AED": {
        "displayName": {
          "one": "dirham ya Falme za Kiarabu",
          "other": "dirham za Falme za Kiarabu"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFN": {
        "displayName": {
          "one": "afghani ya Afghanistan",
          "other": "afghani za Afghanistan"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALL": {
        "displayName": {
          "one": "lek ya Albania",
          "other": "lek za Albania"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "one": "dram ya Armenia",
          "other": "dram za Armenia"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "one": "guilder ya Antili za Kiholanzi",
          "other": "guilder za Antili za Kiholanzi"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "one": "kwanza ya Angola",
          "other": "kwanza za Angola"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "ARS": {
        "displayName": {
          "one": "peso ya Ajentina",
          "other": "peso za Ajentina"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "AUD": {
        "displayName": {
          "one": "dola ya Australia",
          "other": "dola za Australia"
        },
        "narrow": "$",
        "symbol": "A$"
      },
      "AWG": {
        "displayName": {
          "one": "florin ya Aruba",
          "other": "florin za Aruba"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZN": {
        "displayName": {
          "one": "manat ya Azerbaijan",
          "other": "manat za Azerbaijan"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAM": {
        "displayName": {
          "one": "convertible mark ya Bosnia na Hezegovina",
          "other": "convertible mark za Bosnia na Hezegovina"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BBD": {
        "displayName": {
          "one": "dola ya Barbados",
          "other": "dola za Barbados"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "one": "taka ya Bangladesh",
          "other": "taka za Bangladesh"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BGN": {
        "displayName": {
          "one": "lev ya Bulgaria",
          "other": "lev za Bulgaria"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BHD": {
        "displayName": {
          "one": "dinari ya Bahareni",
          "other": "dinari za Bahareni"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "one": "faranga ya Burundi",
          "other": "faranga za Burundi"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "one": "dola ya Bermuda",
          "other": "dola za Bermuda"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "one": "dola ya Brunei",
          "other": "dola za Brunei"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "one": "Boliviano ya Bolivia",
          "other": "Boliviano za Bolivia"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BRL": {
        "displayName": {
          "one": "Real ya Brazil",
          "other": "Real za Brazil"
        },
        "narrow": "R$",
        "symbol": "R$"
      },
      "BSD": {
        "displayName": {
          "one": "dola ya Bahamas",
          "other": "dola za Bahamas"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "one": "ngultrum ya Bhutan",
          "other": "ngultrum za Bhutan"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BWP": {
        "displayName": {
          "one": "pula ya Botswana",
          "other": "pula za Botswana"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYN": {
        "displayName": {
          "one": "ruble ya Belarus",
          "other": "ruble za Belarus"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "one": "Ruble ya Belarusi (2000–2016)",
          "other": "Ruble za Belarusi (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "one": "dola ya Belize",
          "other": "dola za Belize"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "one": "dola ya Canada",
          "other": "dola za Canada"
        },
        "narrow": "$",
        "symbol": "CA$"
      },
      "CDF": {
        "displayName": {
          "one": "faranga ya Kongo",
          "other": "faranga za Kongo"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHF": {
        "displayName": {
          "one": "faranga ya Uswisi",
          "other": "faranga za Uswisi"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CLP": {
        "displayName": {
          "one": "Peso ya Chile",
          "other": "Peso za Chile"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "one": "yuan ya Uchina (huru)",
          "other": "yuan za Uchina (huru)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNY": {
        "displayName": {
          "one": "yuan ya Uchina",
          "other": "yuan za Uchina"
        },
        "narrow": "¥",
        "symbol": "CN¥"
      },
      "COP": {
        "displayName": {
          "one": "peso ya Kolombia",
          "other": "peso za Kolombia"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "CRC": {
        "displayName": {
          "one": "colon ya Kostarika",
          "other": "colon za Kostarika"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CUC": {
        "displayName": {
          "one": "peso ya Kuba inayoweza kubadilishwa",
          "other": "peso za Kuba zinazoweza kubadilishwa"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "one": "peso ya Kuba",
          "other": "peso za Kuba"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "one": "eskudo ya Cape Verde",
          "other": "eskudo za Cape Verde"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CZK": {
        "displayName": {
          "one": "koruna ya Jamhuri ya Czech",
          "other": "koruna za Jamhuri ya Czech"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DJF": {
        "displayName": {
          "one": "faranga ya Jibuti",
          "other": "faranga za Jibuti"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "one": "krone ya Denmark",
          "other": "krone za Denmark"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "one": "peso ya Dominika",
          "other": "peso za Dominika"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "one": "dinar ya Aljeria",
          "other": "dinar za Aljeria"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "EGP": {
        "displayName": {
          "one": "pauni ya Misri",
          "other": "pauni za Misri"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "one": "nakfa ya Eritrea",
          "other": "nakfa za Eritrea"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESP": {
        "displayName": {
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "one": "birr ya Uhabeshi",
          "other": "birr za Uhabeshi"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "yuro"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FJD": {
        "displayName": {
          "one": "dola ya Fiji",
          "other": "dola za Fiji"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "one": "Pauni ya Visiwa vya Falkland",
          "other": "Pauni za Visiwa vya Falkland"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "GBP": {
        "displayName": {
          "one": "pauni ya Uingereza",
          "other": "pauni za Uingereza"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEL": {
        "displayName": {
          "one": "lari ya Jojia",
          "other": "lari za Jojia"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHC": {
        "displayName": {
          "other": "Sedi ya Ghana"
        },
        "narrow": "GHC",
        "symbol": "GHC"
      },
      "GHS": {
        "displayName": {
          "one": "cedi ya Ghana",
          "other": "cedi za Ghana"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "one": "pauni ya Gibraltar",
          "other": "pauni za Gibraltar"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "one": "dalasi ya Gambia",
          "other": "dalasi za Gambia"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "one": "faranga ya Guinea",
          "other": "faranga za Guinea"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GNS": {
        "displayName": {
          "other": "Faranga ya Gine"
        },
        "narrow": "GNS",
        "symbol": "GNS"
      },
      "GTQ": {
        "displayName": {
          "one": "quetzal ya Guatemala",
          "other": "quetzal za Guatemala"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GYD": {
        "displayName": {
          "one": "dola ya Guyana",
          "other": "dola za Guyana"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "one": "dola ya Hong Kong",
          "other": "dola za Hong Kong"
        },
        "narrow": "$",
        "symbol": "HK$"
      },
      "HNL": {
        "displayName": {
          "one": "lempira ya Hondurasi",
          "other": "lempira za Hondurasi"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRK": {
        "displayName": {
          "one": "kuna ya Korasia",
          "other": "kuna za Korasia"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "one": "gourde ya Haiti",
          "other": "gourde za Haiti"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "one": "forint ya Hungaria",
          "other": "forint za Hungaria"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "one": "rupiah ya Indonesia",
          "other": "rupiah za Indonesia"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "ILS": {
        "displayName": {
          "one": "shekeli mpya ya Israel",
          "other": "shekeli mpya za Israel"
        },
        "narrow": "₪",
        "symbol": "₪"
      },
      "INR": {
        "displayName": {
          "one": "rupia ya India",
          "other": "rupia za India"
        },
        "narrow": "₹",
        "symbol": "₹"
      },
      "IQD": {
        "displayName": {
          "one": "dinari ya Iraki",
          "other": "dinari za Iraki"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "one": "rial ya Iran",
          "other": "rial za Iran"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISK": {
        "displayName": {
          "one": "krona ya Aisilandi",
          "other": "krona za Aisilandi"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "JMD": {
        "displayName": {
          "one": "dola ya Jamaika",
          "other": "dola za Jamaika"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "one": "dinari ya Jordan",
          "other": "dinari za Jordan"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "one": "yen ya Japani",
          "other": "yen za Japani"
        },
        "narrow": "¥",
        "symbol": "JP¥"
      },
      "KES": {
        "displayName": {
          "one": "shilingi ya Kenya",
          "other": "shilingi za Kenya"
        },
        "narrow": "Ksh",
        "symbol": "Ksh"
      },
      "KGS": {
        "displayName": {
          "one": "som ya Kyrgystan",
          "other": "som za Kyrgystan"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "one": "riel ya Kambodia",
          "other": "riel za Kambodia"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "one": "faranga ya Komoro",
          "other": "faranga za Komoro"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "one": "won ya Korea Kaskazini",
          "other": "won za Korea Kaskazini"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRW": {
        "displayName": {
          "one": "won ya Korea Kusini",
          "other": "won za Korea Kusini"
        },
        "narrow": "₩",
        "symbol": "₩"
      },
      "KWD": {
        "displayName": {
          "one": "dinari ya Kuwait",
          "other": "dinari za Kuwait"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "one": "dola ya Visiwa vya Cayman",
          "other": "dola za Visiwa vya Cayman"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "one": "tenge ya Kazakhstan",
          "other": "tenge za Kazakhstan"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "one": "kip ya Laosi",
          "other": "kip za Laosi"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "one": "pauni ya Lebanon",
          "other": "pauni za Lebanon"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "one": "rupia ya Sri Lanka",
          "other": "rupia za Sri Lanka"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "one": "dola ya Liberia",
          "other": "dola za Liberia"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "other": "Loti za Lesoto"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "one": "Litas ya Lithuania",
          "other": "Litas za Lithuania"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LVL": {
        "displayName": {
          "one": "Lats ya Lativia",
          "other": "Lats za Lativia"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LYD": {
        "displayName": {
          "one": "dinari ya Libya",
          "other": "dinari za Libya"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "one": "dirham ya Moroko",
          "other": "dirham za Moroko"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MDL": {
        "displayName": {
          "one": "leu ya Moldova",
          "other": "leu za Moldova"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "one": "ariari ya Madagaska",
          "other": "ariari za Madagaska"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MKD": {
        "displayName": {
          "one": "denar ya Masedonia",
          "other": "denar za Masedonia"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MMK": {
        "displayName": {
          "one": "kyat ya Myanmar",
          "other": "kyat za Myanmar"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "one": "tugrik ya Mongolia",
          "other": "tugrik za Mongolia"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "one": "pataca ya Macau",
          "other": "pataca za Macau"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "one": "ouguiya ya Mauritania (1973–2017)",
          "other": "ouguiya za Mauritania (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "one": "ouguiya ya Moritania",
          "other": "ouguiya za Moritania"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MUR": {
        "displayName": {
          "one": "rupia ya Morisi",
          "other": "rupia za Morisi"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVR": {
        "displayName": {
          "one": "rufiyaa ya Maldives",
          "other": "rufiyaa za Maldives"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "one": "kwacha ya Malawi",
          "other": "kwacha za Malawi"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "one": "peso ya Meksiko",
          "other": "peso za Meksiko"
        },
        "narrow": "$",
        "symbol": "MX$"
      },
      "MYR": {
        "displayName": {
          "one": "ringgit ya Malaysia",
          "other": "ringgit za Malaysia"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZM": {
        "displayName": {
          "other": "metikali ya Msumbiji (1980–2006)"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "one": "metikali ya Msumbiji",
          "other": "metikali za Msumbiji"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "one": "dola ya Namibia",
          "other": "dola za Namibia"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "one": "naira ya Nigeria",
          "other": "naira za Nigeria"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIO": {
        "displayName": {
          "one": "cordoba ya Nikaragwa",
          "other": "cordoba za Nikaragwa"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NOK": {
        "displayName": {
          "one": "krone ya Norwe",
          "other": "krone za Norwe"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "one": "rupia ya Nepal",
          "other": "rupia za Nepal"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "one": "dola ya Nyuzilandi",
          "other": "dola za Nyuzilandi"
        },
        "narrow": "$",
        "symbol": "NZ$"
      },
      "OMR": {
        "displayName": {
          "one": "rial ya Omani",
          "other": "rial za Omani"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "other": "balboa ya Panama"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEN": {
        "displayName": {
          "one": "sol ya Peru",
          "other": "sol za Peru"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PGK": {
        "displayName": {
          "one": "kina ya Papua New Guinea",
          "other": "kina za Papua New Guinea"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "one": "peso ya Ufilipino",
          "other": "peso za Ufilipino"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "one": "rupia ya Pakistan",
          "other": "rupia za Pakistan"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "one": "zloty ya Poland",
          "other": "zloty za Poland"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PYG": {
        "displayName": {
          "one": "guarani ya Paragwai",
          "other": "guarani za Paragwai"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "other": "rial ya Qatar"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RON": {
        "displayName": {
          "one": "leu ya Romania",
          "other": "leu za Romania"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "one": "dinar ya Serbia",
          "other": "dinar za Serbia"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "one": "ruble ya Urusi",
          "other": "ruble za Urusi"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RWF": {
        "displayName": {
          "one": "faranga ya Rwanda",
          "other": "faranga za Rwanda"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "one": "riyal ya Saudia",
          "other": "riyal za Saudia"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "one": "dola ya Visiwa vya Solomon",
          "other": "dola za Visiwa vya Solomon"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "one": "rupia ya Ushelisheli",
          "other": "rupia za Ushelisheli"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDG": {
        "displayName": {
          "one": "pauni ya Sudan",
          "other": "pauni za Sudan"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "one": "pauni ya Sudani (1957–1998)",
          "other": "pauni za Sudani (1957–1998)"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "one": "krona ya Uswidi",
          "other": "krona za Uswidi"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "one": "dola ya Singapore",
          "other": "dola za Singapore"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "one": "pauni ya St. Helena",
          "other": "pauni za St. Helena"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SLL": {
        "displayName": {
          "one": "leone ya Siera Leoni",
          "other": "leone za Siera Leoni"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "one": "shilingi ya Somalia",
          "other": "shilingi za Somalia"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "one": "dola ya Suriname",
          "other": "dola za Suriname"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SSP": {
        "displayName": {
          "one": "pauni ya Sudan Kusini",
          "other": "pauni za Sudan Kusini"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "one": "dobra ya Sao Tome na Principe (1977–2017)",
          "other": "dobra za Sao Tome na Principe (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "one": "dobra ya Sao Tome na Principe",
          "other": "dobra za Sao Tome na Principe"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SYP": {
        "displayName": {
          "one": "pauni ya Syria",
          "other": "pauni za Syria"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "one": "lilangeni ya Uswazi",
          "other": "emalangeni za Uswazi"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "one": "baht ya Tailandi",
          "other": "baht za Tailandi"
        },
        "narrow": "฿",
        "symbol": "฿"
      },
      "TJS": {
        "displayName": {
          "one": "somoni ya Tajikistan",
          "other": "somoni za Tajikistan"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMT": {
        "displayName": {
          "one": "manat ya Turkmenistan",
          "other": "manat za Turkmenistan"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "one": "dinari ya Tunisia",
          "other": "dinari za Tunisia"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "one": "paʻanga ya Tonga",
          "other": "paʻanga za Tonga"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TRY": {
        "displayName": {
          "one": "lira ya Uturuki",
          "other": "lira za Uturuki"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "one": "Dola ya Trinidad na Tobago",
          "other": "Dola za Trinidad na Tobago"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "one": "dola ya Taiwan",
          "other": "dola za Taiwan"
        },
        "narrow": "NT$",
        "symbol": "NT$"
      },
      "TZS": {
        "displayName": {
          "one": "shilingi ya Tanzania",
          "other": "shilingi za Tanzania"
        },
        "narrow": "TSh",
        "symbol": "TSh"
      },
      "UAH": {
        "displayName": {
          "one": "hryvnia ya Ukraine",
          "other": "hryvnia za Ukraine"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UGX": {
        "displayName": {
          "one": "shilingi ya Uganda",
          "other": "shilingi za Uganda"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "one": "dola ya Marekani",
          "other": "dola za Marekani"
        },
        "narrow": "$",
        "symbol": "US$"
      },
      "UYU": {
        "displayName": {
          "one": "peso ya Urugwai",
          "other": "peso za Urugwai"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "one": "som ya Uzbekistan",
          "other": "som za Uzbekistan"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEF": {
        "displayName": {
          "one": "Bolivar ya Venezuela (2008–2018)",
          "other": "Bolivar za Venezuela (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "one": "bolivar ya Venezuela",
          "other": "bolivar za Venezuela"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "one": "dong ya Vietnam",
          "other": "dong za Vietnam"
        },
        "narrow": "₫",
        "symbol": "₫"
      },
      "VUV": {
        "displayName": {
          "one": "vatu ya Vanuatu",
          "other": "vatu za Vanuatu"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "one": "tala ya Samoa",
          "other": "tala za Samoa"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "one": "faranga ya Afrika ya Kati CFA",
          "other": "faranga za Afrika ya Kati CFA"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XCD": {
        "displayName": {
          "one": "dola ya Karibi Mashariki",
          "other": "dola za Karibi Mashariki"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XOF": {
        "displayName": {
          "one": "faranga ya Afrika Magharibi CFA",
          "other": "faranga za Afrika Magharibi CFA"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPF": {
        "displayName": {
          "one": "faranga ya CFP",
          "other": "faranga za CFP"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XXX": {
        "displayName": {
          "other": "(sarafu isiyojulikana)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YER": {
        "displayName": {
          "one": "rial ya Yemen",
          "other": "rial za Yemen"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "ZAR": {
        "displayName": {
          "one": "randi ya Afrika Kusini",
          "other": "randi za Afrika Kusini"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "other": "Kwacha ya Zambia (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "one": "kwacha ya Zambia",
          "other": "kwacha za Zambia"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZWD": {
        "displayName": {
          "other": "Dola ya Zimbabwe"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "¤ #,##0.00",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "¤ elfu0"
            },
            "10000": {
              "other": "¤ elfu00;¤elfu -00"
            },
            "100000": {
              "other": "¤ laki000;¤laki -000"
            },
            "1000000": {
              "one": "¤ 0M;¤-0M",
              "other": "¤ 0M"
            },
            "10000000": {
              "one": "¤ 00M;¤M-00M",
              "other": "¤ 00M;¤-00M"
            },
            "100000000": {
              "one": "¤ 000M;¤Milioni-000",
              "other": "¤ 000M"
            },
            "1000000000": {
              "other": "¤ 0B;¤-0B"
            },
            "10000000000": {
              "other": "¤ 00B;¤-00B"
            },
            "100000000000": {
              "other": "¤ 000B;¤-000B"
            },
            "1000000000000": {
              "one": "¤ 0T;¤-0T",
              "other": "¤ 0T"
            },
            "10000000000000": {
              "one": "¤ 00T;¤-00T",
              "other": "¤ 00T"
            },
            "100000000000000": {
              "other": "¤ 000T;¤-000T"
            }
          },
          "standard": "¤ #,##0.00",
          "unitPattern": "{1} {0}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "elfu 0;elfu -0"
            },
            "10000": {
              "other": "elfu 00;elfu -00"
            },
            "100000": {
              "other": "elfu 000;elfu -000"
            },
            "1000000": {
              "other": "milioni 0;milioni -0"
            },
            "10000000": {
              "other": "milioni 00;milioni -00"
            },
            "100000000": {
              "other": "milioni 000;milioni -000"
            },
            "1000000000": {
              "other": "bilioni 0;bilioni -0"
            },
            "10000000000": {
              "other": "bilioni 00;bilioni -00"
            },
            "100000000000": {
              "other": "bilioni 000;bilioni -000"
            },
            "1000000000000": {
              "other": "trilioni 0;trilioni -0"
            },
            "10000000000000": {
              "other": "trilioni 00;trilioni -00"
            },
            "100000000000000": {
              "other": "trilioni 000;trilioni -000"
            }
          },
          "short": {
            "1000": {
              "other": "elfu 0;elfu -0"
            },
            "10000": {
              "other": "elfu 00;elfu -00"
            },
            "100000": {
              "other": "elfu 000;elfu -000"
            },
            "1000000": {
              "one": "0M;-0M",
              "other": "0M"
            },
            "10000000": {
              "one": "00M;-00M",
              "other": "00M"
            },
            "100000000": {
              "one": "000M;-000M",
              "other": "000M"
            },
            "1000000000": {
              "other": "0B;-0B"
            },
            "10000000000": {
              "other": "00B;-00B"
            },
            "100000000000": {
              "other": "000B;-000B"
            },
            "1000000000000": {
              "one": "0T;-0T",
              "other": "0T"
            },
            "10000000000000": {
              "one": "00T;-00T",
              "other": "00T"
            },
            "100000000000000": {
              "one": "000T;-000T",
              "other": "000T"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0%"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "~",
          "decimal": ".",
          "exponential": "E",
          "group": ",",
          "infinity": "∞",
          "list": ";",
          "minusSign": "-",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "–",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0} kwa kila {1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "other": "ekari {0}"
          },
          "narrow": {
            "other": "Ekari {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "ekari {0}"
          }
        },
        "bit": {
          "long": {
            "other": "biti {0}"
          },
          "narrow": {
            "other": "biti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "biti {0}"
          }
        },
        "byte": {
          "long": {
            "other": "baiti {0}"
          },
          "narrow": {
            "other": "baiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "baiti {0}"
          }
        },
        "celsius": {
          "long": {
            "other": "nyuzi {0}"
          },
          "narrow": {
            "other": "{0}°C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°C"
          }
        },
        "centimeter": {
          "long": {
            "other": "sentimita {0}"
          },
          "narrow": {
            "other": "cm {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila sentimita",
            "narrow": "{0} kwa kila sentimita",
            "short": "{0} kwa kila sentimita"
          },
          "short": {
            "other": "sentimita {0}"
          }
        },
        "day": {
          "long": {
            "other": "siku {0}"
          },
          "narrow": {
            "other": "siku {0}"
          },
          "perUnit": {
            "long": "{0} kwa siku",
            "narrow": "{0} kwa siku",
            "short": "{0} kwa siku"
          },
          "short": {
            "other": "siku {0}"
          }
        },
        "degree": {
          "long": {
            "other": "digrii {0}"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "digrii {0}"
          }
        },
        "fahrenheit": {
          "long": {
            "other": "nyuzi za farenheiti {0}"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°F"
          }
        },
        "fluid-ounce": {
          "long": {
            "one": "aunsi {0} ya ujazo",
            "other": "aunsi {0} za ujazo"
          },
          "narrow": {
            "other": "fl oz {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "fl oz {0}"
          }
        },
        "foot": {
          "long": {
            "other": "futi {0}"
          },
          "narrow": {
            "other": "futi {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila futi",
            "narrow": "{0} kwa kila futi",
            "short": "{0} kwa kila futi"
          },
          "short": {
            "other": "futi {0}"
          }
        },
        "gallon": {
          "long": {
            "other": "galoni {0}"
          },
          "narrow": {
            "other": "galoni {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila galoni",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "galoni {0}"
          }
        },
        "gigabit": {
          "long": {
            "other": "gigabiti {0}"
          },
          "narrow": {
            "other": "gigabiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "gigabiti {0}"
          }
        },
        "gigabyte": {
          "long": {
            "other": "gigabaiti {0}"
          },
          "narrow": {
            "other": "GB {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "GB {0}"
          }
        },
        "gram": {
          "long": {
            "other": "gramu {0}"
          },
          "narrow": {
            "other": "gramu {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila gramu",
            "narrow": "{0} kwa kila gramu",
            "short": "{0} kwa kila gramu"
          },
          "short": {
            "other": "gramu {0}"
          }
        },
        "hectare": {
          "long": {
            "other": "hekta {0}"
          },
          "narrow": {
            "other": "ha {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "hekta {0}"
          }
        },
        "hour": {
          "long": {
            "other": "saa {0}"
          },
          "narrow": {
            "other": "saa {0}"
          },
          "perUnit": {
            "long": "{0} kwa saa",
            "narrow": "{0} kwa saa",
            "short": "{0} kwa saa"
          },
          "short": {
            "other": "saa {0}"
          }
        },
        "inch": {
          "long": {
            "other": "inchi {0}"
          },
          "narrow": {
            "other": "inchi {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila inchi",
            "narrow": "{0} kwa kila inchi",
            "short": "{0} kwa kila inchi"
          },
          "short": {
            "other": "inchi {0}"
          }
        },
        "kilobit": {
          "long": {
            "other": "kilobiti {0}"
          },
          "narrow": {
            "other": "kilobiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "kilobiti {0}"
          }
        },
        "kilobyte": {
          "long": {
            "other": "kilobaiti {0}"
          },
          "narrow": {
            "other": "kilobaiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "kilobaiti {0}"
          }
        },
        "kilogram": {
          "long": {
            "other": "kilogramu {0}"
          },
          "narrow": {
            "other": "kg {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila kilogramu",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "kg {0}"
          }
        },
        "kilometer": {
          "long": {
            "other": "kilomita {0}"
          },
          "narrow": {
            "other": "km {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila kilomita",
            "narrow": "{0} kwa kila kilomita",
            "short": "{0} kwa kila kilomita"
          },
          "short": {
            "other": "km {0}"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "kilomita {0} kwa saa"
          },
          "narrow": {
            "other": "km {0}/saa"
          },
          "perUnit": {
          },
          "short": {
            "other": "km {0}/saa"
          }
        },
        "liter": {
          "long": {
            "other": "lita {0}"
          },
          "narrow": {
            "other": "lita {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila lita",
            "narrow": "{0} kwa kila lita",
            "short": "{0} kwa kila lita"
          },
          "short": {
            "other": "lita {0}"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "lita {0} kwa kilomita"
          },
          "narrow": {
            "other": "lita {0} kwa kilomita"
          },
          "perUnit": {
          },
          "short": {
            "other": "lita {0} kwa kilomita"
          }
        },
        "megabit": {
          "long": {
            "other": "megabiti {0}"
          },
          "narrow": {
            "other": "megabiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "megabiti {0}"
          }
        },
        "megabyte": {
          "long": {
            "other": "megabaiti {0}"
          },
          "narrow": {
            "other": "MB {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "MB {0}"
          }
        },
        "meter": {
          "long": {
            "other": "mita {0}"
          },
          "narrow": {
            "other": "mita {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila mita",
            "narrow": "{0} kwa kila mita",
            "short": "{0} kwa kila mita"
          },
          "short": {
            "other": "mita {0}"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "mita {0} kwa sekunde"
          },
          "narrow": {
            "other": "m {0}/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "m/s {0}"
          }
        },
        "mile": {
          "long": {
            "other": "maili {0}"
          },
          "narrow": {
            "other": "maili {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "maili {0}"
          }
        },
        "mile-per-gallon": {
          "long": {
            "other": "maili {0} kwa kila galoni"
          },
          "narrow": {
            "other": "mpg {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "mpg {0}"
          }
        },
        "mile-per-hour": {
          "long": {
            "other": "maili {0} kwa saa"
          },
          "narrow": {
            "other": "mi {0}/saa"
          },
          "perUnit": {
          },
          "short": {
            "other": "mph {0}"
          }
        },
        "mile-scandinavian": {
          "long": {
            "one": "maili {0} ya skandinavia",
            "other": "maili {0} za skandinavia"
          },
          "narrow": {
            "other": "smi {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "smi {0}"
          }
        },
        "milliliter": {
          "long": {
            "other": "mililita {0}"
          },
          "narrow": {
            "other": "mililita {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "mililita {0}"
          }
        },
        "millimeter": {
          "long": {
            "other": "milimita {0}"
          },
          "narrow": {
            "other": "mm {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "milimita {0}"
          }
        },
        "millisecond": {
          "long": {
            "other": "millisekunde {0}"
          },
          "narrow": {
            "other": "ms {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "ms {0}"
          }
        },
        "minute": {
          "long": {
            "other": "dakika {0}"
          },
          "narrow": {
            "other": "dak {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila dakika",
            "narrow": "{0} kwa kila dakika",
            "short": "{0} kwa kila dakika"
          },
          "short": {
            "other": "dakika {0}"
          }
        },
        "month": {
          "long": {
            "one": "mwezi {0}",
            "other": "miezi {0}"
          },
          "narrow": {
            "one": "mwezi {0}",
            "other": "miezi {0}"
          },
          "perUnit": {
            "long": "{0} kwa mwezi",
            "narrow": "{0} kwa mwezi",
            "short": "{0} kwa mwezi"
          },
          "short": {
            "one": "mwezi {0}",
            "other": "miezi {0}"
          }
        },
        "ounce": {
          "long": {
            "other": "aunsi {0}"
          },
          "narrow": {
            "other": "Aunsi {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila aunsi",
            "narrow": "{0}/oz",
            "short": "{0}/oz"
          },
          "short": {
            "other": "aunsi {0}"
          }
        },
        "percent": {
          "long": {
            "other": "asilimia {0}"
          },
          "narrow": {
            "other": "asilimia {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "asilimia {0}"
          }
        },
        "petabyte": {
          "long": {
            "other": "petabaiti {0}"
          },
          "narrow": {
            "other": "PB {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "PB {0}"
          }
        },
        "pound": {
          "long": {
            "other": "ratili {0}"
          },
          "narrow": {
            "other": "Ratili {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila ratili",
            "narrow": "{0}/lb",
            "short": "{0}/lb"
          },
          "short": {
            "other": "ratili {0}"
          }
        },
        "second": {
          "long": {
            "other": "sekunde {0}"
          },
          "narrow": {
            "other": "sek {0}"
          },
          "perUnit": {
            "long": "{0} kwa kila sekunde",
            "narrow": "{0} kwa kila sek",
            "short": "{0} kwa kila sekunde"
          },
          "short": {
            "other": "sekunde {0}"
          }
        },
        "stone": {
          "long": {
            "one": "jiwe {0}",
            "other": "mawe {0}"
          },
          "narrow": {
            "other": "st {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "st {0}"
          }
        },
        "terabit": {
          "long": {
            "other": "terabiti {0}"
          },
          "narrow": {
            "other": "terabiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "terabiti {0}"
          }
        },
        "terabyte": {
          "long": {
            "other": "terabaiti {0}"
          },
          "narrow": {
            "other": "terabaiti {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "terabaiti {0}"
          }
        },
        "week": {
          "long": {
            "other": "wiki {0}"
          },
          "narrow": {
            "other": "wiki {0}"
          },
          "perUnit": {
            "long": "{0} kwa wiki",
            "narrow": "{0} kwa wiki",
            "short": "{0} kwa wiki"
          },
          "short": {
            "other": "wiki {0}"
          }
        },
        "yard": {
          "long": {
            "other": "yadi {0}"
          },
          "narrow": {
            "other": "yadi {0}"
          },
          "perUnit": {
          },
          "short": {
            "other": "yadi {0}"
          }
        },
        "year": {
          "long": {
            "one": "mwaka {0}",
            "other": "miaka {0}"
          },
          "narrow": {
            "one": "mwaka {0}",
            "other": "miaka {0}"
          },
          "perUnit": {
            "long": "{0} kwa mwaka",
            "narrow": "{0} kwa mwaka",
            "short": "{0} kwa mwaka"
          },
          "short": {
            "one": "mwaka {0}",
            "other": "miaka {0}"
          }
        }
      }
    }
  },
  "locale": "sw"
})
}